module.exports = __webpack_public_path__ + "static/media/Leave02.9f35122e.svg";